var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.title,
      width: "600",
      pad: "0",
      dialog: _vm.show,
      show_title: false,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            !_vm.Data
              ? _c("v-boilerplate", {
                  staticClass: "pa-0",
                  attrs: { type: "article , actions" },
                })
              : _vm._e(),
            _vm.Data
              ? _c(
                  "v-container",
                  { staticClass: "pa-5", attrs: { fluid: "" } },
                  [
                    _c(
                      "v-sheet",
                      { staticClass: "text-h4 text--primary px-3 py-2" },
                      [_vm._v(_vm._s(_vm.Data.message_title))]
                    ),
                    _c(
                      "v-sheet",
                      {
                        staticClass:
                          "text-body-2 text-right text--secondary px-3",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$getDateTime(
                              _vm.Data.send_start_utc_datetime,
                              "YYYY/MM/DD"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "v-sheet",
                      {
                        staticClass: "pa-3 text-body-1",
                        attrs: { "min-height": "150" },
                        domProps: {
                          innerHTML: _vm._s(_vm.Data.message_content),
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.Data.message_content) + " ")]
                    ),
                    Number(_vm.Data.read_flag)
                      ? _c(
                          "v-sheet",
                          { staticClass: "px-3 my-0 mx-0" },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                disabled: true,
                                color: "primary",
                                label: _vm.$t(
                                  "label_essweb_Announcement_dialog_hasBeenReadLabel"
                                ),
                              },
                              model: {
                                value: _vm.Data.read_flag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Data, "read_flag", $$v)
                                },
                                expression: "Data.read_flag",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    Number(_vm.Data.read_flag) == 0 &&
                    _vm.canEdit &&
                    Number(_vm.Data.is_confirm_read)
                      ? _c(
                          "v-sheet",
                          { staticClass: "px-3 my-0 mx-0" },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                disabled: false,
                                color: "primary",
                                label: _vm.$t(
                                  "label_essweb_Announcement_dialog_sendReceiptToSenderLabel"
                                ),
                              },
                              model: {
                                value: _vm.sendReceipt,
                                callback: function ($$v) {
                                  _vm.sendReceipt = $$v
                                },
                                expression: "sendReceipt",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-sheet",
                      { staticClass: "d-flex flex-row justify-space-around" },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            attrs: { text: "", color: "primary" },
                            on: { click: _vm.closeDialog },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("label_essweb_form_tools_oKBtnLabel")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }